import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  overallAttendance: {
    paddingTop: 10,
    fontSize: 16,
    color: '#666',
  },
  lessonAttendance: {
    fontSize: 16,
    color: '#666',
  },
  heading: {
    marginBottom: 40,
  },
  lessonWrapper: {
    marginBottom: 40,
  },
  lessonHeader: {
    padding: 20,
    backgroundColor: '#F6F6F8',
    marginBottom: 20,
  },
  lessonHeaderHeading: {
    color: '#327AB7',
    fontSize: 22,
    lineHeight: 1,
  },
  lessonGradesHeading: {
    fontSize: 18,
    lineHeight: 1,
    marginTop: 10,
  },
  lessonGradesList: {
    paddingTop: 0,
    '& li': {
      padding: 0,
    },
  },
  teacherDescription: {
    border: '1px solid #ddd',
    borderRadius: 5,
    padding: 20,
    marginBottom: 20,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};


class AcademicReportsDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: {},
    };

    this.axiosCancel = null;

    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      academicReport,
      selectedPupil,
    } = this.props;

    this.setState({
      isLoading: true,
    });

    axios
      .get(
        `${window.apiUrl}/getacademicreport/${academicReport.id}?pupil_id=${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => { })
    ;
  }

  render() {
    const {
      t,
      classes,
      academicReport,
    } = this.props;
    const {
      isLoading,
      isLoaded,
      data,
    } = this.state;

    return (
      <div className="academic-reports-details">
        {isLoading && (
          <CircularProgress />
        )}
        {isLoaded && academicReport && (
          <>
            <Grid container justify="space-between" spacing={4} className={classes.heading}>
              <Grid item>
                <Typography variant="h4">{academicReport.name}</Typography>
              </Grid>
              <Grid item>
                {data.overall_attendance_percentage !== null && (
                  <Typography className={classes.overallAttendance}>
                    {t('Session attendance = {{percentage}}%', { percentage: data.overall_attendance_percentage })}
                  </Typography>
                )}
              </Grid>
            </Grid>
            {data.lessons.length === 0 && (
              <Typography variant="h5">{t('No data found for this academic report')}</Typography>
            )}
            {data.lessons.map((lesson) => {
              return (
                <div key={lesson.id} className={classes.lessonWrapper}>
                  <div className={classes.lessonHeader}>
                    <Grid container justify="space-between" spacing={4}>
                      <Grid item>
                        <Typography variant="h5" className={classes.lessonHeaderHeading}>{lesson.lesson_name}</Typography>
                      </Grid>
                      <Grid item>
                        {lesson.attendance_percentage !== null && (
                          <Typography className={classes.lessonAttendance}>
                            {t('Attendance = {{precentage}}%', { lesson: data.attendance_percentage })}
                          </Typography>
                        )}
                        <Grid item>
                          {lesson.grades.length > 0 && (
                            <>
                              <Typography variant="h6" className={classes.lessonGradesHeading}>{t('Grades')}</Typography>
                              <List className={classes.lessonGradesList}>
                                {lesson.grades.map((lessonGrade) => {
                                  return (
                                    <ListItem key={lessonGrade.field_name}>
                                      <span>{lessonGrade.field_name}:&nbsp;</span>
                                      <b>{lessonGrade.grade}</b>
                                    </ListItem>
                                  )
                                })}
                              </List>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {lesson.teachers.map((lessonTeacher) => {
                      return (
                        <div key={lessonTeacher.id}>
                          <Typography variant="h6">{lessonTeacher.teacher_name}</Typography>
                        </div>
                      )
                    })}
                  </div>
                  {lesson.teachers.map((lessonTeacher) => {
                    return (
                      <div key={lessonTeacher.id} className={classes.teacherDescription}>
                        <b>{lessonTeacher.teacher_name}</b>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: lessonTeacher.text,
                          }}
                        ></div>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(AcademicReportsDetails)))
);
